export const esimDescriptionApp = [
    {
        description: 'Ouvrez la notification qui vous dirige directement dans les paramètres de votre ligne',
        id: '1',
    },
    {
        description: 'Cliquez sur Installer ma eSIM',
        id: '2',
    },
];
export const esimDescriptionClient = [
    {
        description: 'Rendez-vous dans la rubrique Mes commandes et cliquez sur Installer ma eSIM',
        id: 'd1',
    },
    {
        description: 'Scannez le QR code avec votre téléphone et laissez-vous guider',
        id: 'd2',
    },
];
